import FASTWAX from '../common/fastwax';
import CatalogTableAccountOrder from './table/account/order';

FASTWAX.CatalogTableAccountOrder = CatalogTableAccountOrder;
window.FASTWAX = FASTWAX;


/** WEBPACK FOOTER **
 ** ./src/catalog/lib.js
 **/